import React, { useState, useEffect } from 'react';

import { Popover } from 'antd';

import styled from 'styled-components';

import { getNow } from '@libs/NwMoment';

import { useProjectContext } from '@contexts/ProjectContext';

import { forceReloadProject } from '@hooks/API/Project/UseProject';

import AddPackageDrawer from '@components/ActivePackages/AddPackageDrawer';
import EventDrawer from '@components/EventDrawer/EventDrawer';
import { NwAddButton, NwButton } from '@components/Gui/NwButton';
import PackageDrawer from '@components/PackageDrawer/PackageDrawer';

import AddProjectEventDropdownContent from './AddProjectEventDropdownContent';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div``;

const CreateForm = ({ eventType, currentProject, handleCloseDrawer, fetchData, onAddedPackage, afterRemove }) => {
    switch (eventType.type) {
        case 'Event':
        case 'ToDo':
        case 'Travel':
        case 'Accommodation':
        case 'FollowUp':
        case 'Meeting':
            return (
                <EventDrawer
                    eventType={eventType.type}
                    show={true}
                    eventInfo={eventType.eventInfo}
                    projectId={currentProject.ID}
                    viewMode="create"
                    allDay={true}
                    dateSelected={getNow()}
                    onClose={handleCloseDrawer}
                    afterUpdate={fetchData}
                    afterRemove={afterRemove}
                />
            );
        case 'Package':
            return (
                <AddPackageDrawer
                    packageName={currentProject.Name}
                    onAddedPackage={onAddedPackage}
                    projectId={currentProject.ID}
                    onClose={handleCloseDrawer}
                />
            );
        default:
            return null;
    }
};

const AddProjectEventDropdown = () => {
    const { projectData: currentProject } = useProjectContext();
    const [isOpenDrawer, setOpenDrawer] = useState(false);
    const [eventType, setEventType] = useState();
    const [newPackageId, setNewPackageId] = useState();
    const [open, setOpen] = useState(false);

    const afterRemove = () => {
        fetchData();
        setOpenDrawer(false);
        setEventType();
    };

    const fetchData = async (event, type) => {
        await forceReloadProject(currentProject.ID);
        setOpenDrawer(false);
        setEventType();
    };

    const onAddedPackage = (packId) => {
        fetchData();
        setOpenDrawer(false);
        setNewPackageId(packId);
    };

    const handleClosePackageDrawer = () => {
        setNewPackageId();
    };

    const handleOpenNewPackageDrawer = () => {
        setEventType({ type: 'Package' });
        setOpen(false);
        setOpenDrawer(true);
    };

    const handleCreateEvent = (type) => {
        setEventType(type);
        setOpen(false);
        setOpenDrawer(true);
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    return currentProject ? (
        <Wrapper>
            <Popover
                zIndex={9999}
                overlayClassName="folder-popover"
                placement="bottomRight"
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                content={
                    <AddProjectEventDropdownContent
                        onCreateEvent={handleCreateEvent}
                        onCreatePackage={handleOpenNewPackageDrawer}
                    />
                }
            >
                {open ? (
                    <NwButton size="small" icon={byPrefixAndName.fasl['times']} label="close" ghost />
                ) : (
                    <NwAddButton size="small" label="add" ghost />
                )}
            </Popover>
            {currentProject && isOpenDrawer ? (
                <CreateForm
                    eventType={eventType}
                    currentProject={currentProject}
                    handleCloseDrawer={handleCloseDrawer}
                    fetchData={fetchData}
                    onAddedPackage={onAddedPackage}
                    handleClosePackageDrawer={handleClosePackageDrawer}
                    afterRemove={afterRemove}
                />
            ) : null}
            {newPackageId && (
                <PackageDrawer
                    packageId={newPackageId}
                    onClose={() => {
                        setNewPackageId();
                    }}
                />
            )}
        </Wrapper>
    ) : (
        <div />
    );
};

export default AddProjectEventDropdown;
